export default __webpack_public_path__ + "static/media/500.580676d6.svg";